module.exports = __webpack_public_path__ + "img/img_card01.f6aa14cf.png";